import { MdAnalytics } from "react-icons/md";
import { IoMdCloseCircleOutline } from "react-icons/io";
import { HiShieldExclamation } from "react-icons/hi";
const data=[

    {
        icon:<HiShieldExclamation />,
        heading:'Best interest rates on the market',
        detail:'Exercitation in fugiat est ut ad ea cupidatat ut in cupidatat occaecat ut occaecat consequat est minim minim esse tempor laborum consequat esse adipisicing eu reprehenderit enim.',
    },
    {
        icon:<IoMdCloseCircleOutline />,
        heading:'Prevent unstable prices',
        detail:'Exercitation in fugiat est ut ad ea cupidatat ut in cupidatat occaecat ut occaecat consequat est minim minim esse tempor laborum consequat esse adipisicing eu reprehenderit enim.',
    },
    {
        icon:<MdAnalytics />,
        heading:'Best price on the market',
        detail:'Exercitation in fugiat est ut ad ea cupidatat ut in cupidatat occaecat ut occaecat consequat est minim minim esse tempor laborum consequat esse adipisicing eu reprehenderit enim.',
    },
]
export default data;